const React = require('react');
const classnames = require('classnames');
require('./phone-verification-code.scss');
const config = require('../../../config');
const commonHelper = require('../../../helper/common-helper');
const shopId = commonHelper.getUrlParam('shopId');

const defaultCountry = {
  isAllowSendCode: true,
  areaCode: '86',
  phoneRegulation: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
  country: '中国'
};
sessionStorage.setItem('nationTelCode', defaultCountry.areaCode);

import { formatMessage } from '../../../intl/helper';
import { FormattedMessage } from 'react-intl';
import muiText from '../../../intl/messages/mui';
import ConfirmDialog from '../dialog/confirm-dialog';

module.exports = React.createClass({
  displayName: 'PhoneVerificationCode',
  propTypes: {
    placeholder: React.PropTypes.object,
    className: React.PropTypes.string,
    phoneNum: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number
    ]),
    phoneNumDisabled: React.PropTypes.bool,
    fetchCodeBtnText: React.PropTypes.string,
    completeFlag: React.PropTypes.number,
    onGetVerificationCode: React.PropTypes.func,
    onGetMobileBindStatus: React.PropTypes.func,
    onGetMobileOccupyStatus: React.PropTypes.func,
    onCompleteInput: React.PropTypes.func,
    setErrorMsg: React.PropTypes.func,
    fromBindPhone: React.PropTypes.bool,
    fromModifyBindPhone: React.PropTypes.bool,
    compareWithOldPhone: React.PropTypes.bool,
    oldPhone: React.PropTypes.string,
    currentCountry: React.PropTypes.object
  },

  getDefaultProps() {
    return {
      phoneNum: '',
      phoneNumDisabled: false,
      currentCountry: defaultCountry
    };
  },

  getInitialState() {
    const { phoneNum } = this.props;

    return {
      phoneNum: phoneNum || '',
      code: '',
      password: '',
      seconds: 0,
      canReceivePhoneNum: true,
      showSetTradePwd: false,
      showTradePwdInputStatus: false,
      showNeedDataRecoveryDialog: false,
      fetchCodeBtnText: this.props.fromBindPhone
        ? formatMessage(muiText.muiclickToGet)
        : formatMessage(muiText.muigetVerification)
    };
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.completeFlag !== this.props.completeFlag) {
      this.handleCompleteInput();
    }

    const { phoneNum, canReceivePhoneNum } = this.state;
    if (canReceivePhoneNum && nextProps.phoneNum !== phoneNum) {
      this.setState({ phoneNum: nextProps.phoneNum });
    }

    if (nextProps && nextProps.currentCountry) {
      this.setState({ currentCountry: this.props.currentCountry });
      sessionStorage.setItem(
        'nationTelCode',
        nextProps.currentCountry && nextProps.currentCountry.areaCode
      );
    }
  },

  componentWillUnmount() {
    this.clearWaiting();
  },

  getInputInfo() {
    const keys = ['phoneNum', 'code', 'password'];
    const info = {};

    keys.forEach(key => {
      info[key] = this.state[key];
    });

    info.code = info.code || '';

    info.nationTelCode = sessionStorage.getItem('nationTelCode');
    return {
      data: info,
      validation: this.validateInput(info),
      showSetTradePwd: this.state.showSetTradePwd
    }; // 新增路径参数
  },

  isNumberStr(value) {
    return /^\d*$/.test(value);
  },

  isValidPhoneNum(phoneNum, currentCountry) {
    let result = false;

    if (!currentCountry) {
      return result;
    }

    const valiatePhone = items => {
      items.forEach(item => {
        const regexp = new RegExp(currentCountry.phoneRegulation);
        result = result || regexp.test(phoneNum);
      });
    };

    valiatePhone([currentCountry]);

    return result;
  },

  isAllowSendCode(phoneNum, currentNation) {
    const { compareWithOldPhone, oldPhone, currentCountry, type } = this.props;

    if (type === 'noCode') {
      return true;
    }

    const regexp = new RegExp(currentCountry && currentCountry.phoneRegulation);
    const shouldAllowSendCode =
      currentCountry && currentCountry.isAllowSendCode && regexp.test(phoneNum);

    if (compareWithOldPhone && oldPhone) {
      return (
        shouldAllowSendCode && (compareWithOldPhone && oldPhone !== phoneNum)
      );
    }

    return shouldAllowSendCode;
  },

  validateInput(info) {
    const { phoneNum, code, password } = info;
    const {
      placeholder = {
        phoneNum: formatMessage(muiText.muiinputPN),
        code: formatMessage(muiText.muiinputVerificationCode),
        tradePwd: formatMessage(muiText.muisetPassWord)
      },
      currentCountry
    } = this.props;
    const { showSetTradePwd } = this.state;
    if (!phoneNum) {
      return {
        valid: false,
        code: 'PHONENUM_EMPTY',
        msg: placeholder.phoneNum
      };
    }

    if (!this.isValidPhoneNum(phoneNum, currentCountry)) {
      return {
        valid: false,
        code: 'PHONENUM_INVALID',
        msg: formatMessage(muiText.muiPNPrompt)
      };
    }

    if (!code) {
      return { valid: false, code: 'CODE_EMPTY', msg: placeholder.code };
    }
    if (!/^\d{4,6}$/.test(code)) {
      return {
        valid: false,
        code: 'CODE_INVALID',
        msg: formatMessage(muiText.muiverificationPrompt)
      };
    }

    if (!password && showSetTradePwd) {
      return {
        valid: false,
        code: 'PASSWORD_EMPTY',
        msg: placeholder.tradePwd
      };
    }
    if (!/^\d{6}$/.test(password) && showSetTradePwd) {
      return {
        valid: false,
        code: 'PASSWORD_INVALID',
        msg: formatMessage(muiText.muiPWPrompt)
      };
    }

    return { valid: true, code: '', msg: '' };
  },

  handlePhoneNumChange(evt) {
    const value = evt.target.value.trim();

    const { compareWithOldPhone, oldPhone, setErrorMsg } = this.props;
    if (compareWithOldPhone && oldPhone) {
      if (value === oldPhone) {
        setErrorMsg(formatMessage(muiText.muisamePrompt));
      }
    }
    if (!this.isNumberStr(value)) {
      return;
    }

    this.setState({ phoneNum: value, canReceivePhoneNum: false });
  },

  handleCompleteInput() {
    const info = this.getInputInfo();

    if (this.props.onCompleteInput) {
      this.props.onCompleteInput(info);
    }
  },

  handleVerificationCodeChange(evt) {
    const value = evt.target.value.trim();
    if (!this.isNumberStr(value)) {
      return;
    }

    this.setState({ code: value });
  },

  handleVerificationPwdChange(evt) {
    const value = evt.target.value.trim();
    if (!this.isNumberStr(value)) {
      return;
    }

    this.setState({ password: value });
  },

  handleFetchCodeBtnTouchTap(evt) {
    const btn = evt.target;
    if (btn.disabled) {
      return;
    }
    this.refs.phoneVerificationNumber.blur();
    this.refs.phoneVerificationCode.blur();
    this._touchTabed = true;
    this.sendFetchVerificationCodeRequest();
    this.waitOneMinute();
  },

  clearWaiting() {
    if (this._timer) {
      window.clearTimeout(this._timer);
      this.setState({ seconds: 0 });
      this._timer = null;
    }
  },

  sendFetchVerificationCodeRequest() {
    const { phoneNum } = this.state;
    const { onGetVerificationCode, currentCountry } = this.props;
    // 两个入口
    const { fromBindPhone, fromModifyBindPhone } = this.props;
    // 两个方法
    const { onGetMobileBindStatus, onGetMobileOccupyStatus } = this.props;

    if (onGetVerificationCode) {
      /* fromBindPhone */
      if (onGetMobileBindStatus && fromBindPhone) {
        onGetMobileBindStatus(
          (isCustomer, isOpenAutoCustomer, needDataRecovery) => {
            // needDataRecovery,用于茶百道数据修复问题
            if (!needDataRecovery) {
              // 发送验证码之前先验证手机号 获取到 isBindMobile
              if (isOpenAutoCustomer && !isCustomer) {
                this.setState({ showSetTradePwd: true });
              }
              onGetVerificationCode(phoneNum, currentCountry.areaCode);
            } else {
              // 弹窗提示用户修复数据
              this.setState({
                showNeedDataRecoveryDialog: true
              });
            }
          },
          this.state.phoneNum,
          currentCountry.areaCode
        );
        return;
      }

      /* fromModifyBindPhone */
      if (onGetMobileOccupyStatus && fromModifyBindPhone) {
        onGetMobileOccupyStatus(() => {
          // 发送验证码之前先验证手机号 获取到 isBindMobile
          onGetVerificationCode(phoneNum, currentCountry.areaCode);
        }, this.state.phoneNum);
        return;
      }

      onGetVerificationCode(phoneNum, currentCountry.areaCode);
    }
  },

  waitOneMinute() {
    const next = seconds => {
      if (seconds === 0) {
        this.setState({ seconds: 0 });
        return;
      }

      this.setState({ seconds });
      this._timer = window.setTimeout(() => {
        next(seconds - 1);
      }, 1000);
    };
    next(60);
  },

  changeTradePwdInputStatus() {
    const { showTradePwdInputStatus } = this.state;
    this.setState({ showTradePwdInputStatus: !showTradePwdInputStatus });
  },

  goDataRecoveryPage() {
    const url = `${config.dataRecoveryURL}?shopId=${shopId}`;
    location.href = url;
  },

  render() {
    const {
      className,
      placeholder = {
        phoneNum: formatMessage(muiText.muiinputPN),
        code: formatMessage(muiText.muiinputVerificationCode),
        tradePwd: formatMessage(muiText.muisetPassWord)
      },
      phoneNumDisabled,
      currentCountry
    } = this.props;
    const {
      showSetTradePwd,
      showTradePwdInputStatus,
      fetchCodeBtnText,
      showNeedDataRecoveryDialog
    } = this.state;
    const { seconds, phoneNum, code, password } = this.state;

    let btnInfo = null;
    if (seconds > 0) {
      btnInfo = { text: `${seconds}s`, disabled: true };
    } else {
      const text = this._touchTabed
        ? formatMessage(muiText.muireGet)
        : fetchCodeBtnText;
      btnInfo = {
        text,
        disabled: !this.isAllowSendCode(phoneNum, currentCountry)
      };
    }

    const prefixCls = classnames('phone-verification-code', {
      [className]: !!className
    });

    return (
      <div className={prefixCls}>
        <button
          className="btn btn--yellow"
          disabled={btnInfo.disabled}
          onTouchTap={this.handleFetchCodeBtnTouchTap}
        >
          {btnInfo.text}
        </button>
        <div className="form-group phone phone--modify">
          {this.props.must === 'mine-reset-password' && !this.props.isChina && (
            <span
              className="international-areaCode"
              style={{ fontSize: 15, paddingRight: 15, color: '#666' }}
            >
              {currentCountry && currentCountry.areaCode}
            </span>
          )}
          <input
            type="tel"
            disabled={phoneNumDisabled}
            value={phoneNum}
            placeholder={placeholder.phoneNum}
            maxLength={11}
            onChange={this.handlePhoneNumChange}
            ref="phoneVerificationNumber"
          />
        </div>
        <div className="form-group verification-code verification-code--modify">
          <input
            type="tel"
            value={code}
            placeholder={placeholder.code}
            maxLength="6"
            onChange={this.handleVerificationCodeChange}
            ref="phoneVerificationCode"
          />
        </div>
        {showSetTradePwd && (
          <div className="form-group password">
            <input
              type={!showTradePwdInputStatus ? 'password' : 'text'}
              value={password}
              placeholder={placeholder.tradePwd}
              maxLength="6"
              onChange={this.handleVerificationPwdChange}
              ref="phoneVerificationPwd"
            />
            <i
              className={classnames(
                'tradepwdstatus',
                { 'tradepwdstatus--hide': !showTradePwdInputStatus },
                { 'tradepwdstatus--show': showTradePwdInputStatus }
              )}
              onTouchTap={this.changeTradePwdInputStatus}
            />
          </div>
        )}

        {showNeedDataRecoveryDialog && (
          <ConfirmDialog
            onCancel={() => {
              this.setState({
                showNeedDataRecoveryDialog: false
              });
            }}
            onConfirm={this.goDataRecoveryPage}
            cancelText={formatMessage(muiText.muiUpgradeNot)}
            confirmText={formatMessage(muiText.muiUpgradeNow)}
            onClose={() => {
              this.setState({ showNeedDataRecoveryDialog: false });
            }}
          >
            <div className="need-data-recovery__info">
              <FormattedMessage {...muiText.muiAssetMergerMsg} />
            </div>
          </ConfirmDialog>
        )}
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/component/mui/form/phone-verification-code.jsx